// extracted by mini-css-extract-plugin
export var chevron = "_2m-d";
export var disabled = "_2m-b";
export var error = "_2m-c";
export var hideBorder = "_2m-1";
export var icon = "_2m-e";
export var input = "_2m-0";
export var large = "_2m-f";
export var open = "_2m-9";
export var placeholder = "_2m-a";
export var regular = "_2m-5";
export var singleRowInput = "_2m-2";
export var singleSelectInput = "_2m-3 _2m-0";
export var small = "_2m-4";
export var spinnerContainer = "_2m-i";
export var tag = "_2m-7";
export var tagsContainer = "_2m-8";
export var tagsInput = "_2m-6 _2m-0";
export var xSmall = "_2m-g";
export var xxSmall = "_2m-h";